export const buildPriceLabelFromPriceIndex = (index: string) => {
    return `${parseInt(index) * 500} - ${parseInt(index) * 500 + 500}`;
};



// WEBPACK FOOTER //
// ./src/helpers/buildPriceLabelFromPriceIndex.ts